import type { RewriteSet, RuleContext } from '../types';
import { buildAboutVariants } from './about';
import { buildHeadlineVariants } from './headline';

export { PLACEHOLDER, extractFacts } from './facts';
export type { ProfileFacts } from './facts';

/**
 * Builds the rewrite scaffolds shown alongside the report.
 *
 * Pure, like the rest of `src/core/`: same profile in, same suggestions out.
 * This is also the natural seam for an AI-powered alternative — swap this one
 * function for a call to a model and the rest of the app is unchanged. That is
 * deliberately left as an extension point rather than a dependency, so the tool
 * stays free, offline, and free of API keys. See `docs/ARCHITECTURE.md`.
 */
export function buildRewrites(ctx: RuleContext): RewriteSet {
  return {
    headline: buildHeadlineVariants(ctx),
    about: buildAboutVariants(ctx),
  };
}
